import { Component, Input, OnInit } from '@angular/core';
import { ShipmentStatus, WccIntegrationStatusType } from '@shared-features/enums/shipments.enum';
import { ShipmentList } from '@features/shipments/models/shipment-list.model';
import { Shipment } from '@features/shared-features/models/shipment.model';

type ClassName =
  | 'primary'
  | 'accent'
  | 'secondary'
  | 'success'
  | 'primary-light'
  | 'turquoise'
  | 'yellow'
  | 'warn'
  | 'gray';

@Component({
  selector: 'app-shipment-status-label',
  templateUrl: './shipment-status-label.component.html',
  styleUrls: ['./shipment-status-label.component.scss'],
})
export class ShipmentStatusLabelComponent implements OnInit {
  @Input() value: ShipmentStatus;
  @Input() shipmentStatus: any = ShipmentStatus;
  @Input() shipment: Shipment | ShipmentList;
  @Input() statusTranslationKey = 'Enum.ShipmentStatus';
  @Input() extraDanger: boolean;
  @Input() generateClassMap: () => { [k: string]: ClassName };
  classMap: { [k: string]: ClassName } = {};
  isCustomer: boolean;
  WccIntegrationStatusType = WccIntegrationStatusType;

  constructor() {}

  ngOnInit(): void {
    this.classMap = this.generateClassMap ? this.generateClassMap() : this.generateDefaultClasses();
  }

  private generateDefaultClasses(): { [k: string]: ClassName } {
    return {
      [ShipmentStatus.OrderPlaced]: 'primary',
      [ShipmentStatus.New]: 'primary',
      [ShipmentStatus.ArriveDropOffLocation]: 'turquoise',
      [ShipmentStatus.Accepted]: 'accent',
      [ShipmentStatus.GoodsLoaded]: 'secondary',
      [ShipmentStatus.Assigned]: 'yellow',
      [ShipmentStatus.InTransit]: 'yellow',
      [ShipmentStatus.Rejected]: 'warn',
      [ShipmentStatus.Canceled]: 'gray',
      [ShipmentStatus.NotFulfilled]: 'warn',
      [ShipmentStatus.Closed]: 'warn',
      [ShipmentStatus.GoodsDelivered]: 'success',
      [ShipmentStatus.ArrivePickupLocation]: 'primary-light',
      [ShipmentStatus.AutoDelivered]: 'success',
    };
  }
}
